import scrollBar from './scrollBar.js';

  

const modalUtils = {

  
  prepareTrigger(trigger) {
    const modalSelector = trigger.getAttribute('data-target');
    const node = document.querySelector(modalSelector);
    if (this.isModal(node)) {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();	  
        this.showModal(node);
      });
    }
  },


  // Устанавливает обработчики, связанные с закрытием модального окна.
  // 1. По нажатию кнопок типа Закрыть.
  // Требует наличия атрибута data-dismiss="modal" на закрывающем элементе.
  // 2. По нажатии клавиши Esc.
  // 3. По клику за пределами модульного окна.
  prepareModal(modal) {

    // Hiding modal by Close button (data-dismiss="modal") click 
    const closeButtons = modal.querySelectorAll('[data-dismiss]');
    closeButtons.forEach((closeButton) => {
      closeButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.hideModal(modal);
      })
    })

    // Hiding modal by ESC
    document.addEventListener('keydown', (e) => {
        if (e.keyCode == 27) {
          if (this.isModalVisible(modal)) {
            this.hideModal(modal);
            e.preventDefault();	
            return;
          }
        }
    });

    // Hiding modal by clicking outside (overlay)
    const modalInner = modal.firstElementChild;
    let mouseDownWasFired = false;
    
    modal.addEventListener('click', (e) => {
      if (!mouseDownWasFired) {
        if (!this.isModalVisible(modal)) return;        
        if (e.target !== modal) return;
        this.hideModal(modal);
        return;
      }
      else {
        mouseDownWasFired = false;
      }
    });

    modalInner.addEventListener('mousedown', (e) => {
      mouseDownWasFired = true;
    });


  },


  // Returns true, if node is modal
  isModal(node) {
    return (node && node.classList.contains('modal'));
  },

  // Returns true, if modal is opened
  isModalVisible(modal) {
      return modal.classList.contains('modal--visible');
  },

  // Hide modal
  hideModal(modal) {
    scrollBar.show();
    modal.classList.remove('modal--visible');
  },
  
  // Show modal
  showModal(modal) {
    scrollBar.hide();
    modal.classList.add('modal--visible');
  }
}


export default modalUtils;